import { Skeleton } from '@/common/components/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/common/components/ui/table';

interface BillingListSkeletonProps {
  rowCount: number;
}

export const BillingListSkeleton = ({ rowCount }: BillingListSkeletonProps) => {
  return (
    <TableBody aria-label="Loading billings...">
      {Array.from({ length: rowCount }).map((_, index) => (
        <TableRow key={`skeleton-${rowCount}-${index}`}>
          {Array.from({ length: 17 }).map((_, cellIndex) => (
            <TableCell key={cellIndex}>
              <Skeleton className="h-4 w-full bg-muted-foreground/20" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
